import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'
import { type App, type Plugin } from 'vue'
import { type AnalyticsClient, setCustomerIOClient } from './analyticsClients'
import { isProdEnv } from '@/utils/isProdEnv'

export interface CustomerIOOptions {
  writeKey: string
}

type LoadableAnalyticsClient = AnalyticsClient & {
  catch?: (onRejected: () => void) => unknown
}

const shouldEnableAnonymousInApp = (): boolean => {
  if (import.meta.env.DEV || import.meta.env.TEST || typeof location === 'undefined') {
    return false
  }

  return isProdEnv()
}

export const customerioPlugin: Plugin = {
  async install(_: App, { writeKey }: CustomerIOOptions): Promise<void> {
    setCustomerIOClient(undefined)

    if (!writeKey) return

    try {
      const instance = AnalyticsBrowser.load(
        {
          writeKey,
        },
        {
          integrations: {
            // Anonymous in-app messages can interfere with local and E2E runs.
            'Customer.io In-App Plugin': {
              anonymousInApp: shouldEnableAnonymousInApp(),
            },
          },
        },
      ) as unknown as LoadableAnalyticsClient

      instance.catch?.(() => {
        console.error('Error loading Customer.io')
        setCustomerIOClient(undefined)
      })

      setCustomerIOClient(instance)
    } catch (err) {
      console.error('Error loading Customer.io: ', err)
    }
  },
}
